import { createSelector } from '@ngrx/store';

import { AppState } from './app.state';
import { selectAppState } from './user.selectors';

export const selectCurrent2FaClientStatus = createSelector(selectAppState, (appState: AppState) => appState.twoFaClientStatus);

export const selectWebMailClientUrl = createSelector(selectAppState, (appState: AppState) => appState.webMailClientUrl);
